import { analyticsConstants } from "../constants/ActionTypes";
import { baseUrl } from '../constants/baseUrl';

export const getAverageTransactionAction = (paramObj, onSuccess, onFailure) => ({
    type: analyticsConstants.GET_AVERAGE_TRANSACTION,
    payload: paramObj,
    meta: {
        type: 'api',
        url: baseUrl + '/average_transaction',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {
            shop_id: paramObj.shopId,
            date_first: paramObj.dateFirst,
            date_second: paramObj.dateSecond,
        },
        options: {
            method: 'GET'
        }
    }
})